<h1>Billing</h1>

<section id="upcoming-bill">
  <h2 class="section-title-row">Upcoming bill</h2>
  <p class="tp-section-info">Upcoming charge for this month's usage</p>
  @if (upcomingInvoice$ | async; as upcomingInvoice) {
    @if (upcomingInvoice === "none") {
      <p>There is no upcoming bill.</p>
    } @else {
      <tp-properties-table>
        <tp-properties-table-row key="Period Beginning">{{ upcomingInvoice.startTime | datetime }}</tp-properties-table-row>
        <tp-properties-table-row key="Current Cost">{{ upcomingInvoice.total | currency }}</tp-properties-table-row>
      </tp-properties-table>
    }
  } @else {
    <tp-spinner/>
  }
</section>

<section id="invoices">
  <h2 class="section-title-row">Invoices</h2>
  <p class="tp-section-info">Past charges for this TypeDB Cloud team</p>
  @if (invoices.ready$ | async) {
    <tp-invoices-table [table]="invoices"/>
    <tp-table-paginator [table]="invoices"/>
  } @else {
    <tp-spinner/>
  }
</section>

<section id="card">
  @if (cardSectionReady) {
    <div class="section-title-row os-payment-info">
      <h2>Payment card</h2>
      @if (creditCard$ | async) {
        <tp-button (click)="openPaymentModal()" [enabled]="true" buttonStyle="secondary stroke" buttonId="updateCard">
          <i class="fa-light fa-pen-to-square"></i> Update Card Info
        </tp-button>
      }
    </div>
    <p class="tp-section-info">Set up a card to use as a payment method</p>
    @if (creditCard$ | async; as card) {
      <tp-properties-table>
        <tp-properties-table-row key="Type">{{ card | creditCardType }}</tp-properties-table-row>
        <tp-properties-table-row key="Cardholder Name">{{ card.name }}</tp-properties-table-row>
        <tp-properties-table-row key="Card Number">Ending in {{ card.lastFourDigits }}</tp-properties-table-row>
        <tp-properties-table-row key="Expiry Date">{{ card | creditCardExpiryDate }}</tp-properties-table-row>
        <tp-properties-table-row key="Billing Address">{{ card | billingAddress }}</tp-properties-table-row>
      </tp-properties-table>
    }
    @if (!(creditCard$ | async)) {
      <div class="integrations-row">
        <tp-integration-card title="Add Card" faIcon="fa-solid fa-credit-card" (click)="openPaymentModal()">
          <p>
            Billing will take place on a monthly basis from the creation of your first cluster.
            You may be charged earlier if the charge for a month exceeds $1000.
          </p>
        </tp-integration-card>
      </div>
    }
  } @else {
    <tp-spinner/>
  }
</section>
<section id="marketplace">
  <div class="section-title-row os-payment-info">
    <h2>Cloud marketplace integrations</h2>
  </div>
  <p class="tp-section-info">Connect your cloud provider account for TypeDB Cloud payments</p>
  <tp-marketplace-cards
    [gcpAccountPresent]="!!(activeGcpAccount$ | async)" [azureAccountPresent]="!!(azureAccount$ | async)"
    [awsAccountPresent]="!!(activeAwsAccount$ | async)" [canDisconnect]="true"
  />
  @if (activeGcpAccount$ | async; as account) {
    <tp-properties-table title="GCP Marketplace Integration Information">
      <tp-properties-table-row key="GCP Marketplace Order Number" matTooltip="Visit https://console.cloud.google.com/marketplace/orders to see your orders">{{ account.orderNumber ?? "" }}</tp-properties-table-row>
    </tp-properties-table>
  }
  @if (activeAwsAccount$ | async; as account) {
    <tp-properties-table title="AWS Marketplace Integration Information">
      <tp-properties-table-row key="AWS Account ID">{{ account.id }}</tp-properties-table-row>
    </tp-properties-table>
  }
  @if (azureAccount$ | async; as account) {
    <tp-properties-table title="Azure Marketplace Integration Information">
      <tp-properties-table-row key="Azure Marketplace Subscription">{{ account.name }}</tp-properties-table-row>
    </tp-properties-table>
  }
</section>

<section>
  <h2 id="credits" class="section-title-row">Credits</h2>
  <p class="tp-section-info">Pay with TypeDB Cloud credits</p>
  @if (credits.ready$ | async) {
    <tp-credits-table [table]="credits"/>
    <tp-table-paginator [table]="credits"/>
  } @else {
    <tp-spinner/>
  }
</section>

<section id="discounts">
  <h2 class="section-title-row">Discounts</h2>
  <p class="tp-section-info">Cost reductions for your TypeDB Cloud bill</p>
  @if (discounts.ready$ | async) {
    <tp-discounts-table [table]="discounts"/>
    <tp-table-paginator [table]="discounts"/>
  } @else {
    <tp-spinner/>
  }
  <div class="billing-summary">
    <p>
      Questions about billing? Email us at
      <a href="mailto:billing@typedb.com">billing&#64;typedb.com</a>.
    </p>
  </div>
</section>
